/**
 * What a Meet click is allowed to do.
 * `schedule` is the only outcome that may open the meeting flow.
 * `ignore` waits until entitlements have loaded, so a Basic click cannot
 * start a meeting while that check is still in flight.
 */
export function meetClickOutcome({ isLoading, isPro } = {}) {
  if (isLoading) return 'ignore';
  if (isPro) return 'schedule';
  return 'gate';
}
